import React from 'react';
import { Spin } from 'antd';

import s from './s.module.less';
import { isKlarityHost } from 'utils/common';
import { PATH } from 'constants/path';

const ClearsessionPage = () => {
    React.useEffect(() => {
        localStorage.clear();
        sessionStorage.clear();
        if (isKlarityHost()) {
            window.location.href = `${window.location.origin}${PATH.PPA_LOGIN}`;
        } else {
            window.location.href = `${window.location.origin}/${PATH.PROVIDER_LOGIN}`;
        }
    }, []);

    return (
        <div className={s.wrap}>
            <Spin />
        </div>
    );
};

export default ClearsessionPage;
